import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/wineTypes'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'wineTypes'

export const metadata = {
  icon: 'align-center',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const WineTypesListPage = createListPage({ metadata, api, actionCreators, Content })
const WineTypesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { WineTypesListPage, WineTypesDetailPage }
